import { Button } from "@chakra-ui/button";
import { Image } from "@chakra-ui/image";
import { Box, Heading, Text } from "@chakra-ui/layout";
import { Link, useHistory } from "react-router-dom";
import theme from "../helpers/theme";

export const Home = () => {
	const history = useHistory();
	return (
		<Box
			w="100%"
			minHeight="100vh"
			display="flex"
			flexDirection="column"
			alignItems="center"
			bgImage="url(https://i.pinimg.com/originals/df/bc/1b/dfbc1b54d97039b02d8fd3c282931269.jpg)"
			bgAttachment="fixed"
		>
			<Box
				id="nav"
				w="100%"
				bgColor="red.50"
				d="flex"
				justifyContent={{ base: "space-between", md: "space-around" }}
				py="2"
				alignItems="center"
			>
				<Image
					w="66px"
					h="66px"
					rounded="full"
					src="https://firebasestorage.googleapis.com/v0/b/kyoi-dev.appspot.com/o/Public%2Flogo.jpg?alt=media&token=c9e88d71-b702-4216-9937-24edcb5678db"
				/>
				{/* links and buttons and all that */}
				<Box>
					<Button variant="ghost" filter="brightness(0.9)" mr={3}>
						About Us
					</Button>
					<Button variant="ghost" filter="brightness(0.9)" mr={5}>
						Learn More
					</Button>
					<Button
						colorScheme={theme.colours.accent}
						as={Link}
						to="/register"
					>
						Sign Up
					</Button>
				</Box>
			</Box>

			{/* main stuff n header section */}

			<Box
				id="header"
				bgColor="pink.50"
				mt={10}
				mb={10}
				p={5}
				rounded="md"
				display="flex"
				flexDir="column"
				alignItems="center"
				width={{ base: "100%", md: "80%", lg: "60%" }}
			>
				<Heading mt={8}>Clubbo</Heading>
				<Text fontSize="lg" mt={2} mb={5}>
					The premier organization platform targeted at education.
				</Text>
				<Button
					px={10}
					py={6}
					mb={10}
					variant="outline"
					colorScheme={theme.colours.accent}
				>
					Register Now!
				</Button>
				<Heading size="lg">Wanna learn more?</Heading>
				<Text fontSize="lg" mt={2} mb={5}>
					Keep Scrolling!
				</Text>
			</Box>
			<Box
				id="cards"
				bg="yellow.50"
				width="100%"
				height="100%"
				p={5}
				mb={10}
				rounded="md"
				display="flex"
				flexDir="column"
				alignItems="center"
			>
				<Heading mt={10}>Your new community is waiting!</Heading>
				<br />
				<Text mb={5} fontSize="lg" textAlign="center" lineHeight="1.6">
					Open yourself up like never before to an eager and wild
					community!
				</Text>
				<Box d="flex" flexWrap="wrap" mb={5}>
					<Box
						w={{ base: "100%", md: "sm" }}
						bgColor="gray.100"
						m={3}
						rounded="lg"
						textAlign="center"
						transition="box-shadow 200ms"
						cursor="pointer"
						onClick={() => history.push("/login")}
						_hover={{
							boxShadow: "0 2px 5px -1px gray",
						}}
					>
						<Heading mx={3} my={7} h={26} fontSize="xl">
							How to get started?
						</Heading>
						<Image
							height="220"
							width="210px"
							ml="auto"
							mr="auto"
							src="https://firebasestorage.googleapis.com/v0/b/kyoi-dev.appspot.com/o/Public%2Fwhaa.png?alt=media&token=6426499e-45a5-4cfb-b249-d6def44d9fe9"
						/>
					</Box>
					<Box
						w={{ base: "100%", md: "sm" }}
						bgColor="gray.100"
						m={3}
						rounded="lg"
						textAlign="center"
						transition="box-shadow 200ms"
						cursor="pointer"
						onClick={() => history.push("/login")}
						_hover={{
							boxShadow: "0 2px 5px -1px gray",
						}}
					>
						<Heading mx={3} my={7} h={26} fontSize="xl">
							How to get started?
						</Heading>
						<Image
							height="220"
							width="210px"
							ml="auto"
							mr="auto"
							src="https://firebasestorage.googleapis.com/v0/b/kyoi-dev.appspot.com/o/Public%2Fwhaa.png?alt=media&token=6426499e-45a5-4cfb-b249-d6def44d9fe9"
						/>
					</Box>
					<Box
						w={{ base: "100%", md: "sm" }}
						bgColor="gray.100"
						m={3}
						rounded="lg"
						textAlign="center"
						transition="box-shadow 200ms"
						cursor="pointer"
						onClick={() => history.push("/login")}
						_hover={{
							boxShadow: "0 2px 5px -1px gray",
						}}
					>
						<Heading mx={3} my={7} h={26} fontSize="xl">
							How to get started?
						</Heading>
						<Image
							height="220"
							width="210px"
							ml="auto"
							mr="auto"
							src="https://firebasestorage.googleapis.com/v0/b/kyoi-dev.appspot.com/o/Public%2Fwhaa.png?alt=media&token=6426499e-45a5-4cfb-b249-d6def44d9fe9"
						/>
					</Box>
				</Box>
			</Box>
			<Box
				id="community"
				bg="blue.50"
				width={{ base: "100%", md: "80%", lg: "60%" }}
				height="100%"
				p={5}
				rounded="md"
				display="flex"
				flexDir="column"
				alignItems="center"
			>
				<Heading mt={10}>The bird protecc.</Heading>
				<br />
				<Text mb={5} fontSize="lg" textAlign="center" lineHeight="1.6">
					What is that, out there on the benches? A creature so
					magnificent words struggle to describe. <br /> It's our
					symbol, it's <strong>our bird</strong>
				</Text>
				<Image
					maxW="md"
					src="https://firebasestorage.googleapis.com/v0/b/kyoi-dev.appspot.com/o/Public%2Flogo.jpg?alt=media&token=c9e88d71-b702-4216-9937-24edcb5678db"
				/>
			</Box>
			<Box id="aboutus"></Box>
		</Box>
	);
};
